export default {
  SearchPlaceholder: 'Please enter domain name/IP',
  DialTestObject: 'dial test object',
  DialingMethod: 'Dialing method',
  DialSourceStation: 'Dial source station (domain name/IP)',
  IpType: 'Dial source station address type',
  DialTestResult: 'Dial test result',
  CompleteTime: 'Complete time',
  DeleteConfirmTitle: 'Are you sure you want to delete the task?',
  DeleteConfirmContent: 'It cannot be restored after deletion, and tasks can be re-added if necessary',
  AddTask: 'Add Task',
  EditTask: 'Edit Task',
  DialingDetails: 'Dialing details',
  Customer: 'client name',
  GatewayBranch: 'gateway branch',
  DomainNamePlaceholder: 'Enter the source site address, separated by multiple newlines',
  PortPlaceholder: '0-65535, default 80, 443. Separate multiple commas, up to 5',
  CreateConfirmTitle: 'Confirm to submit task?',
  CreateConfirmContent: 'After the dial test is completed, you can view the dial test details on the platform',
  EditConfirmTitle: 'Confirm the modification task?',
  EditConfirmContent: 'After the modification is submitted, the dialed test results will not be saved, and the task will be restarted.',
  Unreachable: 'Unreachable',
  PartiallyReachable: 'Partially Reachable',
  AllReachable: 'All Reachable',
  DialTime: 'Dial Time',
  LastCompleteTime: 'The latest dial test completion time',
  User: 'User',
  DomainAndIpMaxLength: (num: number) => `IP + domain name up to ${num}`,
  DomainAndIpRequired: 'Domain name and ip must fill in one',
  EveryDay: 'every day',
  Weekly: 'weekly',
  PerMonth: 'per month',
  Quarterly: 'quarterly',
  // 星期一到星期日
  Mon: 'Monday',
  Tue: 'Tuesday',
  Wed: 'Wednesday',
  Thu: 'Thursday',
  Fri: 'Friday',
  Sat: 'Saturday',
  Sun: 'Sunday',
  Day: 'Day',
  FirstMonth: 'first month of each quarter',
  SecondMonth: 'second month of each quarter',
  LastMonth: 'last month of each quarter',
  MaxPortNum: (num: number) => `Ports support up to ${num}`,
  PortRange: 'The port range is 0-65535',
  UpTo: 'Up to',
  RealTime: 'real time',
  Dialing: 'Dial test in progress',
  CpeSearchPlaceholder: 'Search gateway name/branch name/device name',
  Week: 'Week',
  Month: 'month',
  Date: 'date',
  SelectAll: 'SelectAll',
  DialTestOutlet: 'Dial test outlet',
  Area: 'Area',
}